// extracted by mini-css-extract-plugin
module.exports = {"footerLogo":"footer-module--footer-logo--9Oaih","gadulaLogo":"footer-module--gadula-logo--1wOsd","webmaster":"footer-module--webmaster--2Tfse"};